import { render } from "./ItemOnlyTextComponent.vue?vue&type=template&id=595280a2&scoped=true"
import script from "./ItemOnlyTextComponent.vue?vue&type=script&lang=js"
export * from "./ItemOnlyTextComponent.vue?vue&type=script&lang=js"

import "./ItemOnlyTextComponent.vue?vue&type=style&index=0&id=595280a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595280a2"]])

export default __exports__